import { useEffect } from "react";
import { useLocation } from "react-router";
import { trackPageView } from "~/lib/fpd/tracker.client";

export default function PageViewTracker() {
    const location = useLocation();
    useEffect(() => {
        trackPageView();
    }, [location.pathname]);
    return <></>;
}
